import React from 'react';
import { detectMediaType } from './Utils';
import { TString } from '../Response/Utils';
interface Props {
	url: string;
	name?: string;
}

const MediaRenderer = (props: Props) => {
	const { url, name } = props;
	const mediaType = detectMediaType(url);
	return mediaType ? (
		mediaType === 'image' ? (
			url.indexOf('drive.google.com') > -1 ? (
				<img
					src={`https://drive.google.com/uc?export=view&id=${
						url.split('d/')[1].split('/view')[0]
					}`}
					alt=''
				/>
			) : (
				<img
					src={url}
					style={{ width: '100%' }}
					alt={`${name ? name : TString({ labelName: 'mediaLabel' })} ${TString(
						{
							labelName: 'imageLabel',
						}
					)}`}
				/>
			)
		) : mediaType === 'video' ? (
			<video style={{ width: '100%', height: '100%' }} controls={true}>
				<source src={url}></source>
			</video>
		) : mediaType === 'iframe' ? (
			url.indexOf('drive.google.com') > -1 ? (
				<iframe
					title={`${url}`}
					src={`${url.replace('/view', '/preview')}`}
				></iframe>
			) : (
				<iframe
					src={url}
					style={{ width: '100%', height: '100%' }}
					frameBorder='0'
					allowFullScreen
				></iframe>
			)
		) : null
	) : null;
};
export default MediaRenderer;
